enum AppMsgType {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warn',
}

export default AppMsgType
